import { Injectable } from '@angular/core';
import { LoggingService } from './logging/logging.service';
import { DomStorageFallbackService } from './DomStorageFallback.service';

declare var ga: Function;
@Injectable()
export class GoogleAnalyticsService {

    constructor(
        /* istanbul ignore next */
        private domStorageFB: DomStorageFallbackService,
        /* istanbul ignore next */
        private logService: LoggingService
    ) {
    }

    getParamGroupFromService(res, appVersion) {
        try {
            let hroJson, paramJson, gaJson: any = {};
            for (const i in res) {
                if (Object.keys(res[i])) {
                    if (res[i].hasOwnProperty('hro')) {
                        hroJson = res[i].hro;
                    }
                    if (res[i].hasOwnProperty('param')) {
                        paramJson = res[i].param;
                    }
                    Object.keys(res[i]).forEach(key => {
                        const gaValueKeyIndex = key.indexOf('ga_values');
                        if (gaValueKeyIndex === 0) {
                            if (hroJson) {
                                hroJson.GTM_CONTAINER_ID = res[i][key]['gtmContainerId'];
                                hroJson.GA_SAMPLE_RATE_PROPERTY = res[i][key]['sampleRateProperty'];
                                hroJson.WEB_ANALYTICS_DOMAIN_NAME = res[i][key]['analyticsDomainName'];
                                hroJson.APP_VERSION = appVersion;
                            }
                        }
                    });
                }
            }
            gaJson.hro = hroJson;
            gaJson.param = paramJson;
            this.domStorageFB.setItem('ga_json', JSON.stringify(gaJson));
        } catch (error) {
            /* istanbul ignore next */
            if (LoggingService.uConsole) {
                console.log('Error in getParamGroupFromService() function == ', error);
            }
        }
    }

    postGACustomEventTracking(eventType, eventAction, eventLabel) {
        if (this.isUACrossEnabled()) {
            ga('trackerUa1.send', 'event', eventType, eventAction, eventLabel);
        }
        if (this.isUAClientEnabled()) {
            ga('trackerUa2.send', 'event', eventType, eventAction, eventLabel);
        }
        return false;
    }

    postGACustomPageTracking(pageView) {
        if (this.isUACrossEnabled()) {
            ga('trackerUa1.send', 'pageview', pageView);
        }
        if (this.isUAClientEnabled()) {
            ga('trackerUa2.send', 'pageview', pageView);
        }
        return false;
    }

    isUACrossEnabled() {
        let flag = false;
        if (this.domStorageFB.getItem('ga_json')) {
            let hroValue = JSON.parse(this.domStorageFB.getItem('ga_json')).hro;
            if (hroValue['WEB_ANALYTICS_UA_CROSS_TRACKING']) {
                flag = true;
            } else {
                /* istanbul ignore next */
                flag = false;
            }
        }
        return flag;
    }

    isUAClientEnabled() {
        let flag = false;
        if (this.domStorageFB.getItem('ga_json')) {
            let hroValue = JSON.parse(this.domStorageFB.getItem('ga_json')).hro;
            if (hroValue['WEB_ANALYTICS_UA_CLIENT_TRACKING']) {
                flag = true;
            } else {
                /* istanbul ignore next */
                flag = false;
            }
        }
        return flag;
    }
}

